<template>
  <b-dropdown size="sm" :text="currentTask.htmlPriority.name" :variant="priorityBtnVariant">
    <b-dropdown-item :key="priority.value" v-for="priority in priorities" :disabled="priority.value === currentTask.priority" @click="changePriority(priority.value)">{{priority.name}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
 import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
 import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
 import {showError} from 'perform-base/js/flashes';

 export default {
   data() {
     return {
       priorities: [
         {name: 'Low', value: 0},
         {name: 'Normal', value: 1},
         {name: 'High', value: 2},
       ]
     };
   },

   components: {
     bDropdown,
     bDropdownItem,
   },

   computed: {
     currentTask() {
       return this.$store.state.currentTask;
     },
     priorityBtnVariant() {
       return this.$store.state.currentTask.htmlPriority.class;
     }
   },

   methods: {
     changePriority(value) {
       this.$store.dispatch('setCurrentTaskPriority', {
         priority: value
       })
           .catch(() => {
             showError('An error occurred changing the task priority. Try again later.');
           });
     },
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/TaskPrioritySwitcher.vue